import OverviewSection from "./OverviewSection";

const Shop = () => {
    return (
      <div className=" pt-24 ">
        <OverviewSection />
      </div>
    );
  };
  
  export default Shop;